/* eslint-disable no-unused-expressions */
// import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import isEqual from 'lodash.isequal';
// import CornerstoneToolsUtils from '../../../model/CornerstoneToolsUtils';
import store from '../../../store/store';
import { getEnabledElement } from '../../../util/state';
import {
  getCrossWindow2dReferenceLinesEnabled,
  getCrossWindowActiveViewport,
  getCrossWindowWindowId,
  registerCrossWindow2dReferenceLinesElement,
  setCrossWindow2dReferenceLinesEnabled,
} from './crossWindow2dReferenceLines';

let syncViewsGroup;
let syncRefLines;
let activeRefLinesElementIndices = [];
let activeRefLinesSourceIndex;
let referenceLineListenersInitialized = false;

const isEqualArr = (a, b) => a.length === b.length && a.every((v, i) => isEqual(v, b[i]));

const AddedTool = (ApiTool) => {
  let added = false;
  window.cornerstoneTools.store.state.tools.forEach((cornerstoneTool) => {
    if (`${cornerstoneTool.name}Tool` === ApiTool.name) {
      added = true;
    }
  });

  if (!added) cornerstoneTools.addTool(cornerstoneTools.ReferenceLinesTool);
};

const SyncViewsGroup = () => {
  const state = store.getState();
  const { viewsGroup, currentTool } = state.layout;

  if (syncViewsGroup !== undefined) {
    syncViewsGroup.destroy();
  }

  if (viewsGroup !== undefined && viewsGroup.length > 0) {
    const property = currentTool === 'Wwwc' ? 'wwwcSynchronizer' : 'panZoomSynchronizer';
    syncViewsGroup = new cornerstoneTools.Synchronizer('cornerstoneimagerendered', cornerstoneTools[property]);
    // syncViewsGroup = new Synchronizer('cornerstoneimagerendered', cornerstoneTools[property]);

    viewsGroup.length > 0
      && viewsGroup.forEach((index) => {
        const element = getEnabledElement(index);
        if (element !== undefined) {
          syncViewsGroup.add(element);
        }
      });

    // CornerstoneToolsUtils.selectCornerstoneTool(currentTool);
    // AddedTool(cornerstoneTools.WwwcTool);
    // cornerstoneTools.setToolEnabled(currentTool,
    //   {
    //     synchronizationContext: syncViewsGroup,
    //   });
  }

  if (syncViewsGroup !== undefined) syncViewsGroup.enabled = true;
};

export const SyncRefLines = () => {
  const state = store.getState();
  const { elements, isRefLines, selectedViewIndex } = state.layout;
  const activeViewport = getCrossWindowActiveViewport();
  const localWindowId = getCrossWindowWindowId();
  const activeIsLocal = !activeViewport || activeViewport.windowId === localWindowId;
  const sourceIndex = activeViewport && activeViewport.windowId === localWindowId
    ? activeViewport.viewIndex
    : selectedViewIndex;
  const shouldEnableLocalReferenceLines = Boolean(isRefLines || getCrossWindow2dReferenceLinesEnabled());

  const enabledElementIndices = [];
  elements.forEach((_, index) => {
    const element = getEnabledElement(index);
    if (!element) return;
    enabledElementIndices.push(index);
    registerCrossWindow2dReferenceLinesElement(element, index);
  });
  setCrossWindow2dReferenceLinesEnabled(shouldEnableLocalReferenceLines);

  if (!referenceLineListenersInitialized) {
    referenceLineListenersInitialized = true;
    window.addEventListener('viewer-active-viewport-changed', SyncRefLines);
    window.addEventListener('viewer-reference-lines-enabled-changed', SyncRefLines);
  }

  if (!shouldEnableLocalReferenceLines || !activeIsLocal) {
    if (syncRefLines) {
      syncRefLines.destroy();
      cornerstoneTools.setToolDisabled('ReferenceLines');
    }
    syncRefLines = undefined;
    activeRefLinesElementIndices = [];
    activeRefLinesSourceIndex = undefined;
  } else if (shouldEnableLocalReferenceLines && activeIsLocal
    && (!isEqualArr(activeRefLinesElementIndices, enabledElementIndices)
      || activeRefLinesSourceIndex !== sourceIndex || !syncRefLines)) {
    if (syncRefLines) {
      syncRefLines.destroy();
      syncRefLines = undefined;
    }

    if (elements.length > 0) {
      syncRefLines = new cornerstoneTools.Synchronizer('cornerstonenewimage', cornerstoneTools.updateImageSynchronizer);

      enabledElementIndices.forEach((i) => {
        const element = getEnabledElement(i);

        if (element === undefined) {
          return;
        }
        syncRefLines.add(element);

        if (i !== sourceIndex) {
          syncRefLines.removeSource(element);
        }
      });
      AddedTool(cornerstoneTools.ReferenceLinesTool);

      cornerstoneTools.setToolEnabled('ReferenceLines', {
        synchronizationContext: syncRefLines,
      });
      syncRefLines.enabled = true;
    }

    activeRefLinesElementIndices = [...enabledElementIndices];
    activeRefLinesSourceIndex = sourceIndex;
  }
};

let syncStackOfFrames;
let activeSynchedElements = [];

export const SyncStacks = () => {
  const state = store.getState();
  const { elements } = state.layout;

  const isSyncing = elements.some((element) => element.isSynchedFrames);

  if (!isSyncing && syncStackOfFrames !== undefined) {
    syncStackOfFrames.destroy();
    syncStackOfFrames = undefined;

    activeSynchedElements = [];
  } else if (isSyncing && !isEqualArr(activeSynchedElements, elements)) {
    if (syncStackOfFrames !== undefined) {
      syncStackOfFrames.destroy();
      syncStackOfFrames = undefined;
    }

    if (elements.length > 0) {
      syncStackOfFrames = new cornerstoneTools.Synchronizer('cornerstonenewimage', cornerstoneTools.stackImagePositionSynchronizer);

      for (let i = 0; i < elements.length; i++) {
        const element = getEnabledElement(i);

        if (element !== undefined && elements[i].isSynchedFrames) {
          syncStackOfFrames.add(element);
        }
      }
      AddedTool(cornerstoneTools.StackScrollMouseWheelTool);

      cornerstoneTools.setToolEnabled('StackScroll', {
        synchronizationContext: syncStackOfFrames,
      });
      syncStackOfFrames.enabled = true;
    }
    activeSynchedElements = elements.filter((element, i) => elements[i].isSynchedFrames);
  }
};

export const sync = () => {
  SyncViewsGroup();
  SyncRefLines();
  SyncStacks();
};
